var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',_vm._b({staticClass:"ag-theme-alpine",staticStyle:{"height":"70vh"},on:{"grid-ready":_vm.onGridReady,"cell-clicked":_vm.onCellClicked,"row-double-clicked":_vm.onRowDoubleClicked}},'ag-grid-vue',_vm.agReturnRequests,false))}
var staticRenderFns = []

export { render, staticRenderFns }